/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Map_ViewInputs */

const en_ui_map_view = /** @type {(inputs: Ui_Map_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map view`)
};

const de_ui_map_view = /** @type {(inputs: Ui_Map_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartenansicht`)
};

/**
* | output |
* | --- |
* | "Map view" |
*
* @param {Ui_Map_ViewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_map_view = /** @type {((inputs?: Ui_Map_ViewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Map_ViewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_map_view(inputs)
	return de_ui_map_view(inputs)
});